import SelectFieldComponent from './select-field-component';

/***
 * a field that takes in a list of options and then renders a dropdown list populated by those options.
 */
const selectField = angular
    .module('FacilityData.ClientEdit.FormFields.SelectField', [])
    .component('selectField', SelectFieldComponent)
    .name;

export default selectField;


// WEBPACK FOOTER //
// ./app/common/form-fields/select-field/select-field.js